import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
    MatSnackBar,
    MatSnackBarHorizontalPosition,
    MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ToastComponent } from 'src/app/components/toast/toast.component';
import { FormsService } from 'src/app/services/forms.service';
import { getCookie } from 'src/app/utils/get-cookie';
import { IframeSlideComponent } from './iframe-slide/iframe-slide.component';
import { setPresentationAction } from './store/presentation.actions';
import { getPresentationSelectorsState } from './store/presentation.selectors';

@Component({
  selector: 'app-presentation',
  templateUrl: './presentation.component.html',
  styleUrls: ['./presentation.component.scss'],
})
export class PresentationComponent implements OnInit {
  @ViewChild('meuIframe') meuIframe: ElementRef;

  iframeVisivel: boolean = false;

  isIframe = false;

  studyId: number = 0;
  token: string = '';

  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  durationInSeconds = 2;

  check$: Observable<any>;

  constructor(
    public dialog: MatDialog,
    private store: Store,
    private _snackBar: MatSnackBar,
    private readonly formsService: FormsService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.fetchFormsData();
  }

  ativarModoTelaCheia() {
    this.iframeVisivel = true;
    const iframeElement = this.meuIframe.nativeElement;
    if (iframeElement.requestFullscreen) {
      iframeElement.requestFullscreen();
    } else if (iframeElement.mozRequestFullScreen) {
      iframeElement.mozRequestFullScreen();
    } else if (iframeElement.webkitRequestFullscreen) {
      iframeElement.webkitRequestFullscreen();
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(IframeSlideComponent, {
      panelClass: 'iframe-dialog',
    });
    dialogRef.afterClosed().subscribe();
  }

  goToVideo() {
    this.isIframe = true;
  }

  validateStatePage(): void {
    this.setStates(true);
    this.getStates();
  }

  setStates(check: boolean) {
    this.store.dispatch(setPresentationAction({ check }));
  }

  getStates() {
    this.check$ = this.store.select(getPresentationSelectorsState);

    // Assine ao Observable para obter o valor do seletor
    this.check$.subscribe((value) => {});
  }

  fetchFormsData() {
    this.studyId = Number(getCookie('studyId'));
    this.token = getCookie('token');

    if (!this.studyId || !this.token) {
      this._snackBar.openFromComponent(ToastComponent, {
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
        duration: this.durationInSeconds * 2000,
        panelClass: 'red-snackbar',
        data: {
          title:
            'Dados de sessão inválidos. Redirecionando para a techfinance...',
        },
      });
      setTimeout(() => {
        location.href = 'https://app.techfinance.com.br';
      }, this.durationInSeconds * 1000);
      return;
    }

    this.formsService.getForm(this.studyId).subscribe((res: any) => {
      if (res) {
        localStorage.setItem('formsId', res.id);
        document.cookie = `formsId=${res.id}; path=/; domain=.techfinance.com.br`;
      } else {
        this._snackBar.openFromComponent(ToastComponent, {
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
        duration: this.durationInSeconds * 1000,
        panelClass: 'red-snackbar',
        data: {
          title:
            'Estudo não iniciado.',
        },
      });
    setTimeout(() => {
         this.router.navigate(['/home']);
      }, this.durationInSeconds * 1000);
      }
    }, (error) => {
      this._snackBar.openFromComponent(ToastComponent, {
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
        duration: this.durationInSeconds * 1000,
        panelClass: 'red-snackbar',
        data: {
          title:
            'Erro desconhecido, tente mais tarde.',
        },
      });
    setTimeout(() => {
         this.router.navigate(['/home']);
      }, this.durationInSeconds * 1000);

    },

  );
  }
}
